// ============================================================================
// Catalogo de servicos + sugestao inteligente
// ----------------------------------------------------------------------------
// Extraido para modulo proprio porque o ModalOrcamentoCompleto e usado por OS
// e por Agendamentos. Deixar o catalogo dentro de uma pagina obrigaria a
// duplicar em todo lugar que precisasse sugerir servico.
//
// A ordenacao aprende com o uso: o que a oficina mais lanca sobe. O historico
// e por tenant (mesma chave que a tela de OS ja usava), entao uma oficina nao
// enxerga o padrao de trabalho da outra.
// ============================================================================

function tenantId() {
  try {
    const tk = sessionStorage.getItem("access_token") || localStorage.getItem("access_token");
    if (!tk) return sessionStorage.getItem("tenant_id") || localStorage.getItem("tenant_id") || "1";
    return String(JSON.parse(atob(tk.split(".")[1])).tenant_id || "1");
  } catch { return "1"; }
}

const chaveHist = () => "os_busca_historico_tenant_" + tenantId();

export const SERVICOS = [
  { nome:"Troca de oleo", preco:89.90, tipo:"Mao de Obra", categoria:"Lubrificacao" },
  { nome:"Troca de filtro de oleo", preco:45.00, tipo:"Mao de Obra", categoria:"Lubrificacao" },
  { nome:"Troca de filtro de ar", preco:40.00, tipo:"Mao de Obra", categoria:"Filtragem" },
  { nome:"Troca de filtro de cabine", preco:50.00, tipo:"Mao de Obra", categoria:"Filtragem" },
  { nome:"Troca de filtro de combustivel", preco:60.00, tipo:"Mao de Obra", categoria:"Filtragem" },
  { nome:"Alinhamento", preco:120.00, tipo:"Mao de Obra", categoria:"Suspensao" },
  { nome:"Balanceamento", preco:80.00, tipo:"Mao de Obra", categoria:"Suspensao" },
  { nome:"Alinhamento e Balanceamento", preco:180.00, tipo:"Mao de Obra", categoria:"Suspensao" },
  { nome:"Troca de pastilha dianteira", preco:150.00, tipo:"Mao de Obra", categoria:"Freios" },
  { nome:"Troca de pastilha traseira", preco:150.00, tipo:"Mao de Obra", categoria:"Freios" },
  { nome:"Troca de disco de freio", preco:200.00, tipo:"Mao de Obra", categoria:"Freios" },
  { nome:"Sangria de freios", preco:120.00, tipo:"Mao de Obra", categoria:"Freios" },
  { nome:"Revisao de freios completa", preco:350.00, tipo:"Mao de Obra", categoria:"Freios" },
  { nome:"Troca de correia dentada", preco:380.00, tipo:"Mao de Obra", categoria:"Motor" },
  { nome:"Troca de correia alternador", preco:120.00, tipo:"Mao de Obra", categoria:"Motor" },
  { nome:"Troca de vela de ignicao", preco:180.00, tipo:"Mao de Obra", categoria:"Motor" },
  { nome:"Limpeza de bicos injetores", preco:250.00, tipo:"Mao de Obra", categoria:"Motor" },
  { nome:"Troca de bomba d agua", preco:300.00, tipo:"Mao de Obra", categoria:"Motor" },
  { nome:"Troca de termostato", preco:150.00, tipo:"Mao de Obra", categoria:"Motor" },
  { nome:"Revisao completa", preco:450.00, tipo:"Mao de Obra", categoria:"Motor" },
  { nome:"Diagnostico motor", preco:150.00, tipo:"Mao de Obra", categoria:"Motor" },
  { nome:"Diagnostico eletrico", preco:150.00, tipo:"Mao de Obra", categoria:"Eletrica" },
  { nome:"Troca de bateria", preco:80.00, tipo:"Mao de Obra", categoria:"Eletrica" },
  { nome:"Troca de alternador", preco:250.00, tipo:"Mao de Obra", categoria:"Eletrica" },
  { nome:"Troca de motor de arranque", preco:250.00, tipo:"Mao de Obra", categoria:"Eletrica" },
  { nome:"Troca de amortecedor dianteiro", preco:300.00, tipo:"Mao de Obra", categoria:"Suspensao" },
  { nome:"Troca de amortecedor traseiro", preco:300.00, tipo:"Mao de Obra", categoria:"Suspensao" },
  { nome:"Troca de terminal de direcao", preco:150.00, tipo:"Mao de Obra", categoria:"Suspensao" },
  { nome:"Geometria da direcao", preco:200.00, tipo:"Mao de Obra", categoria:"Suspensao" },
  { nome:"Troca de embreagem", preco:600.00, tipo:"Mao de Obra", categoria:"Transmissao" },
  { nome:"Troca de fluido de cambio", preco:150.00, tipo:"Mao de Obra", categoria:"Transmissao" },
  { nome:"Revisao de cambio", preco:400.00, tipo:"Mao de Obra", categoria:"Transmissao" },
  { nome:"Troca de fluido de freio", preco:80.00, tipo:"Mao de Obra", categoria:"Freios" },
  { nome:"Revisao de ar condicionado", preco:300.00, tipo:"Mao de Obra", categoria:"Ar Condicionado" },
  { nome:"Recarga de gas do ar", preco:200.00, tipo:"Mao de Obra", categoria:"Ar Condicionado" },
  { nome:"Higienizacao do ar condicionado", preco:150.00, tipo:"Mao de Obra", categoria:"Ar Condicionado" },
  { nome:"Oleo 5W-30 1L", preco:28.90, tipo:"Peca", categoria:"Lubrificacao" },
  { nome:"Oleo 5W-40 1L", preco:32.90, tipo:"Peca", categoria:"Lubrificacao" },
  { nome:"Oleo 10W-40 1L", preco:24.90, tipo:"Peca", categoria:"Lubrificacao" },
  { nome:"Filtro de oleo", preco:35.00, tipo:"Peca", categoria:"Filtragem" },
  { nome:"Filtro de ar", preco:42.00, tipo:"Peca", categoria:"Filtragem" },
  { nome:"Filtro de cabine", preco:38.00, tipo:"Peca", categoria:"Filtragem" },
  { nome:"Filtro de combustivel", preco:45.00, tipo:"Peca", categoria:"Filtragem" },
  { nome:"Pastilha de freio dianteira", preco:120.00, tipo:"Peca", categoria:"Freios" },
  { nome:"Pastilha de freio traseira", preco:110.00, tipo:"Peca", categoria:"Freios" },
  { nome:"Disco de freio dianteiro", preco:180.00, tipo:"Peca", categoria:"Freios" },
  { nome:"Disco de freio traseiro", preco:160.00, tipo:"Peca", categoria:"Freios" },
  { nome:"Fluido de freio DOT4", preco:22.00, tipo:"Peca", categoria:"Freios" },
  { nome:"Vela de ignicao", preco:18.50, tipo:"Peca", categoria:"Motor" },
  { nome:"Correia dentada", preco:125.00, tipo:"Peca", categoria:"Motor" },
  { nome:"Bomba d agua", preco:180.00, tipo:"Peca", categoria:"Motor" },
  { nome:"Amortecedor dianteiro", preco:320.00, tipo:"Peca", categoria:"Suspensao" },
  { nome:"Amortecedor traseiro", preco:280.00, tipo:"Peca", categoria:"Suspensao" },
  { nome:"Bateria 60Ah", preco:380.00, tipo:"Peca", categoria:"Eletrica" },
  { nome:"Bateria 70Ah", preco:450.00, tipo:"Peca", categoria:"Eletrica" },
];

function historico() {
  try { return JSON.parse(localStorage.getItem(chaveHist()) || "[]"); } catch { return []; }
}

// Registra o uso para que o item suba nas proximas buscas.
export function registrarUso(item) {
  try {
    const h = historico();
    const i = h.findIndex((x) => x.nome === item.nome);
    if (i >= 0) { h[i].usos = (h[i].usos || 1) + 1; h[i].ultimo = Date.now(); }
    else h.unshift({ nome: item.nome, preco: item.preco, usos: 1, ultimo: Date.now() });
    localStorage.setItem(chaveHist(), JSON.stringify(h.slice(0, 40)));
  } catch { /* sem historico e so perder a ordenacao, nao quebra nada */ }
}

// Busca sem acento e sem diferenciar maiuscula. "oleo" acha "Troca de oleo",
// "OLEO" tambem, e "óleo" tambem -- o operador nao deve ter que acertar acento.
const normaliza = (s) =>
  String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");

export function sugerir(termo, limite = 8) {
  const q = normaliza(termo).trim();
  const usos = {};
  for (const h of historico()) usos[h.nome] = h.usos || 0;

  const base = SERVICOS.map((s) => ({ ...s, _usos: usos[s.nome] || 0 }));
  const filtrados = q
    ? base.filter((s) => normaliza(s.nome).includes(q) || normaliza(s.categoria).includes(q))
    : base;

  return filtrados
    .sort((a, b) => {
      if (b._usos !== a._usos) return b._usos - a._usos;      // mais usados primeiro
      if (q) {                                                 // depois, quem comeca com o termo
        const ca = normaliza(a.nome).startsWith(q) ? 0 : 1;
        const cb = normaliza(b.nome).startsWith(q) ? 0 : 1;
        if (ca !== cb) return ca - cb;
      }
      return a.nome.localeCompare(b.nome);
    })
    .slice(0, limite);
}
